import SceButton from '../../../../Common/CommonComponents/sceButton';
import ServiceAccountDetailsComponent from './serviceAccountDetailsComponent';
import overlayClasses from './sceOverlayStyle.scss';
import CheckBox from '../../../../Common/CommonComponents/SceCheckBox';
import classes from './emergencyAlertTurnOnPopup.scss';
import SceTextBox from '../../../../Common/TextBox/sceText';
import GlobalErrorBlock from '../../../../Common/CommonComponents/GlobalErrorBlock/globalErrorBlock';
import NotificationHelper from '../Common/notificationHelper';
import NotificationHelperTwo from '../Common/notificationHelperTwo';
import CPPAccordionComponent from '../Common/emergencyAlertAccordionComponent';
import EmergencyAlertTermsAndCondition from '../Common/EmergencyAlertTermsCondition';
import EmergencyAlertErrCard from '../Common/emergencyAlertErrCard';
import TwoFactorAuthContainer from '../../../common/TwoFactorAuthentication/TwoFactorAuthContainer';
import FocusTrap from "focus-trap-react";
import SceErrorBox from '../../../../Common/ErrorBox/sceErrorBox';

export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      serviceAccountData: this.props.serviceAccountData,
      accordianToggleStatus: { 'email': false, 'voice': false, 'text': false },
      addContactToggleStatus: { 'email': false, 'voice': false, 'text': false },
      addContactLimitArr: { 'email': 0, 'voice': 0, 'text': 0 },
      addContactValueArr: { 'email': ['', '', ''], 'voice': ['', '', ''], 'text': ['', '', ''] },
      addContactEncValueArr: { 'email': ['', '', ''], 'voice': ['', '', ''], 'text': ['', '', ''] },
      addContactCheckedStatusArr: { 'email': [false, false, false], 'voice': [false, false, false], 'text': [false, false, false] },
      isSameValueSelectError: { 'email': [false, false, false], 'voice': [false, false, false], 'text': [false, false, false] },
      twoFactorAuthValues:{'value':'','type':'','encValue':'','isPopUpOpen':false,'addressGuid':this.props.dropDownData.addressGuid,'mainBpNumber':this.props.mainBpNumber,'contactMethodIndex': 0},
      isTurnOnWithoutData: false, isDoneEnabled: false, isTnCSelected: this.props.isViewEdit,  showCheckboxError: false,

    };
    this.selectedServiceAccountArray = [], this.hasMouseDownOnRadio = false, this.isFormSubmitted = false;
    this.fieldKeys = { 'Email': 'email', 'Text Message': 'text', 'Voice Message': 'voice', 'None': 'none' };
    let emailIcon, phoneIcon, addIcon, closeIcon;
    this.emailIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_MailOn.svg';
    this.phoneIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_PhoneOn.svg';
    this.textIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_TextOn.svg';
    this.addIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Action_Add.svg';
    this.closeIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Close.svg';
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  onDoneEnabledButton = (val) => { this.setState({ isDoneEnabled: val }); }
  componentWillMount() {  this.formatAccountData(true);}
  componentDidMount() {document.addEventListener('mousedown', this.handleClickOutside);}
  componentWillUnmount() {  document.removeEventListener('mousedown', this.handleClickOutside);}

  setWrapperRef(node) {
      this.wrapperRef = node;
  }

  handleClickOutside(event) {
      (this.wrapperRef && !this.wrapperRef.contains(event.target)) && this.props.closePopup();
  }
  formatAccountData(thisProps, nextProps) {
    let props = thisProps ? { ...this.props } : { ...nextProps };
    let updatedStateData = { ...this.state }, selectedServiceAccounts;
    let selectedAccount = props.serviceAccountData;
    this.selectedServiceAccountArray.push(selectedAccount);
    updatedStateData.preferenceData = NotificationHelperTwo.getDefaultPreferenceData(props.preferenceData, updatedStateData.serviceAccountData.saAccList[0].premiseNumber, false);
    updatedStateData.accordianToggleStatus = NotificationHelper.getDefaultAccordianToggleStatusData(updatedStateData.accordianToggleStatus, updatedStateData.preferenceData.addContactLimitArr);
    updatedStateData.addContactCheckedStatusArr = updatedStateData.preferenceData.addContactCheckedStatusArr;
    updatedStateData.addContactLimitArr = updatedStateData.preferenceData.addContactLimitArr;
    updatedStateData.addContactValueArr = updatedStateData.preferenceData.addContactValueArr;
    updatedStateData.addContactEncValueArr = updatedStateData.preferenceData.addContactEncValueArr;
    this.setState(updatedStateData);

  }
  onTextChangeHandler(field, index) {
    let updatedStateData = { ...this.state };
    updatedStateData = NotificationHelper.getDefaultErrorStateData(updatedStateData);
    updatedStateData.addContactToggleStatus[field.id] && updatedStateData.addContactLimitArr[field.id] < 3 ? updatedStateData.addContactValueArr[field.id][updatedStateData.addContactLimitArr[field.id]] = field.value : null;
    updatedStateData.addContactToggleStatus[field.id] && updatedStateData.addContactLimitArr[field.id] < 3 && field.encNum && field.encNum !== "" ? updatedStateData.addContactEncValueArr[field.id][updatedStateData.addContactLimitArr[field.id]] = field.encNum : null;
    !updatedStateData.addContactToggleStatus[field.id] ? updatedStateData.addContactValueArr[field.id][index] = field.value : null;
    !updatedStateData.addContactToggleStatus[field.id] && field.encNum && field.encNum !== "" ? updatedStateData.addContactEncValueArr[field.id][index] = field.encNum : null;
    updatedStateData.addContactToggleStatus[field.id] && updatedStateData.addContactLimitArr[field.id] < 3 ? updatedStateData.addContactCheckedStatusArr[field.id][updatedStateData.addContactLimitArr[field.id]] = true : null;
    updatedStateData.addContactToggleStatus[field.id] && updatedStateData.addContactLimitArr[field.id] < 3 ? updatedStateData.addContactLimitArr[field.id] += 1 : null;
    updatedStateData.addContactToggleStatus[field.id] = false;
    this.setState(updatedStateData, () => {
      this.validateForm();
    });
  }
  onAddContactCancelHandler(contactType) {
    let updatedState = { ...this.state };
    updatedState.addContactToggleStatus[contactType] = false;
    this.setState(updatedState, () => { });
  }
  onAddContactClickHandler(contactType) {
    let updatedState = { ...this.state };
    for (let objKey in updatedState.addContactToggleStatus) {
      objKey === contactType ? updatedState.addContactToggleStatus[objKey] = true : updatedState.addContactToggleStatus[objKey] = false;
    }
    this.setState(updatedState, () => { });
  }
  onContactMethodCheckHandler(contactType, index) {
    let updatedState = { ...this.state };
    updatedState.addContactLimitArr[contactType] -= 1;
    if (contactType === 'email') {
      updatedState.addContactValueArr[contactType].splice(index, 1);
      updatedState.addContactValueArr[contactType].push("");
    } else {
      updatedState.addContactEncValueArr[contactType].splice(index, 1);
      updatedState.addContactEncValueArr[contactType].push("");
      updatedState.addContactValueArr[contactType].splice(index, 1);
      updatedState.addContactValueArr[contactType].push("");
    }
    this.setState(updatedState, () => {
      this.validateForm(); 
    });
  }
  onFormDataSaveClickHandler() {
    let turnOnButtonType = (!this.state.isTnCSelected);
    if(turnOnButtonType){
      this.setState({showCheckboxError: true}, () => {
        document.getElementById("pfcscroll").scroll(0,5000); 
 });
    } else {
    this.props.isViewEdit ? window.aUtils.sendAAEvent("button","emergencydone ") : window.aUtils.sendAAEvent("button","emergencyturnon");
    this.isFormSubmitted = true;
    this.forceValidateForm();}
  }
  forceValidateForm() {
    let updatedState = { ...this.state };
    let isAnyEmailCheckedFlag = updatedState.addContactCheckedStatusArr.email[0] || updatedState.addContactCheckedStatusArr.email[1] || updatedState.addContactCheckedStatusArr.email[2];
    let isAnyVoiceCheckedFlag = updatedState.addContactCheckedStatusArr.voice[0] || updatedState.addContactCheckedStatusArr.voice[1] || updatedState.addContactCheckedStatusArr.voice[2];
    let isAnyTextCheckedFlag = updatedState.addContactCheckedStatusArr.text[0] || updatedState.addContactCheckedStatusArr.text[1] || updatedState.addContactCheckedStatusArr.text[2];
    if (isAnyEmailCheckedFlag || isAnyVoiceCheckedFlag || isAnyTextCheckedFlag) {
      updatedState.isTurnOnWithoutData = false;
      this.validateForm();
    } else {
      updatedState.isTurnOnWithoutData = true;
      this.isFormSubmitted = false;
    }
    this.setState(updatedState);
  }
  validateForm() {
    let updatedState = { ...this.state };
    let formValidated = false;
    formValidated = true;
    var reqObj = this.isFormSubmitted ? this.formatObject(updatedState) : {}, viewState = { ...this.props.viewState }, contactType = '', isError = false;
    if (this.isFormSubmitted && reqObj.enrollmentArray[0].existingDeviceArr.length > 0) {
      contactType = reqObj.enrollmentArray[0].existingDeviceArr[0].contactType;
      isError = true;
      this.isFormSubmitted = false;
      this.props.closePopup();
    }
    if (formValidated && this.isFormSubmitted && !isError) {
      viewState.showResidentialSetNotification = false, viewState.showResidentialAssign = false;
      reqObj.viewState = viewState;
      this.props.emergencyAlertEnrollClick(reqObj, viewState);
      this.isFormSubmitted = false;
    } }
  formatObject(updatedState) {
    var preferenceData = NotificationHelperTwo.getDefaultPreferenceData(this.props.preferenceData, this.state.serviceAccountData.saAccList[0].premiseNumber);
    var requestArrays = NotificationHelper.formatObject(this.props.customerAccountData, this.selectedServiceAccountArray, this.strings, updatedState, [preferenceData], [this.props.dropDownData]);
    return requestArrays;}
 
  onModifyCustomerPreference(deviceType, value, maskedValue, contactMethodIndex) {
     
    let updatedState={...this.state};
      this.isFormSubmitted = false;
      updatedState.twoFactorAuthValues.isPopUpOpen=true;      
      updatedState.twoFactorAuthValues.encValue=value;
      updatedState.twoFactorAuthValues.type=deviceType;
      updatedState.twoFactorAuthValues.contactMethodIndex=contactMethodIndex;
      deviceType==='email' ? updatedState.twoFactorAuthValues.value=value :updatedState.twoFactorAuthValues.value=maskedValue;
      this.setState(updatedState,()=>{ });
     
  }
  onTncCheck = (checkStatus) => {
    // this.setState({isTnCSelected: checkStatus});
    this.setState({ isTnCSelected: checkStatus, showCheckboxError: false }); }
  
  twofactorAuthPopupClose=(isTwoFaCompleted)=>{
    let updatedState={...this.state};
    isTwoFaCompleted === true ? window.aUtils.sendAAEvent("button","ok") : null;
    this.onAddContactCancelHandler(updatedState.twoFactorAuthValues.type);
    updatedState.twoFactorAuthValues.isPopUpOpen=false;
    updatedState.twoFactorAuthValues.value='';
    updatedState.twoFactorAuthValues.encValue='';
    updatedState.twoFactorAuthValues.type='';
    updatedState.isDoneEnabled=false;
    this.setState(updatedState);
  }
  onTwoFACompleted=(onTwoFACompleted)=>{
    let updatedState={...this.state};    
    if(onTwoFACompleted){
      let callbackObj = {modifiedValue: updatedState.twoFactorAuthValues.encValue, maskedValue: updatedState.twoFactorAuthValues.value, deviceType: updatedState.twoFactorAuthValues.type};
      this.props.onModifyCustomerPreference(callbackObj);   
      let field = {id: updatedState.twoFactorAuthValues.type, value: updatedState.twoFactorAuthValues.value, encNum: updatedState.twoFactorAuthValues.encValue};
      this.onTextChangeHandler(field, updatedState.twoFactorAuthValues.contactMethodIndex);
    } }

  getViewToShow = () => {
    let doneButton = (this.state.isDoneEnabled);
    const contactTypeArr = [
      { 'headerText': "this.strings.email", 'addAnotherContactText': this.props.strings.emergencyAlertAddEmail, 'contactType': 'email', 'errorId': 'emailError' },
      { 'headerText': "this.strings.voiceMsg", 'addAnotherContactText': this.props.strings.emergencyAlertAddPhone, 'contactType': 'voice', 'errorId': 'voiceError' },
      { 'headerText': "this.strings.textMsg", 'addAnotherContactText': this.props.strings.emergencyAlertAddPhone, 'contactType': 'text', 'errorId': 'textError' }
    ];
    let serviceAccountDetailsJSX = <ServiceAccountDetailsComponent selectedAccount={this.props.selectedAccount} />;
    let turnOnButtonType = (this.state.addContactLimitArr.email <= 0 && this.state.addContactLimitArr.text <= 0 && this.state.addContactLimitArr.voice <= 0) || (!this.state.isTnCSelected);
    let showErrCard = this.props.isErrorCard ? <div className='col-xs-12'><EmergencyAlertErrCard onFormhandler={() => this.onFormDataSaveClickHandler()} /></div> : null;
    let mainHeaderText = this.props.isViewEdit ?  this.props.strings.viewEditHeader:this.props.strings.emergencyAlertTuronHeader;
    let subHeaderText = this.props.isViewEdit ? this.props.strings.viewEditSubHeader:this.props.strings.emergencyAlertSetNotiFor;
    let buttonText = this.props.isViewEdit ? this.props.strings.viewEditBtnTxt:this.props.strings.emergencyAlertTurnOnBtn;
    let atleastOnePrefErr = (turnOnButtonType && this.props.isViewEdit)? <div className={classes.formSubmitErrorCard}> <EmergencyAlertErrCard turnOnButtonType /> </div> :null;
    return (
      <div>
        <div className='row'>
          <div className={'col-xs-12 ' + classes.sceSetNotificationMainHeader}>{mainHeaderText} <button className={classes.iconClose} onClick={this.props.closePopup} ><img  src={this.closeIcon} alt="close Icon"  /></button></div>
        </div>
        {this.state.twoFactorAuthValues.isPopUpOpen ? <TwoFactorAuthContainer factors closePopup={this.twofactorAuthPopupClose}  twoFactorAuthValues={this.state.twoFactorAuthValues} onTwoFACompleted={this.onTwoFACompleted} />
        :
        <div>
        <div id="pfcscroll" className={!this.props.isViewEdit? classes.scrollContentTurnOnPopup:classes.scrollContentViewEditPopup}>
        <div className='row'>
          {showErrCard}
          <div className={'col-xs-12 ' + classes.sceSetNotificationHeader}>{subHeaderText}</div>
        </div>
        <div className={classes.servAccDet}>{serviceAccountDetailsJSX}</div>
        {atleastOnePrefErr}
        <div className={classes.PrefContent}>
          <div><div><div className={classes.notificationLabel}>
            <img className={classes.labelImages} src={this.emailIcon} alt="Email Icon" />{this.props.strings.emergencyAlertEmailNotiTxt}</div><div className={classes.limitText}>{this.props.strings.limitText}</div><div className={classes.dividerLine} />
          </div>
            <div className={classes.textBox}>
              <CPPAccordionComponent
                contactType={contactTypeArr[0].contactType}
                stateData={this.state}
                onAddContactClickHandler={this.onAddContactClickHandler.bind(this)}
                onDoneEnabledButton={this.onDoneEnabledButton}
                onAddContactCancelHandler={this.onAddContactCancelHandler.bind(this)}
                addContactButtonText={contactTypeArr[0].addAnotherContactText}
                onContactMethodCheckHandler={this.onContactMethodCheckHandler.bind(this)}
                onModifyCustomerPreference={this.onModifyCustomerPreference.bind(this)}
                onSelectDropDown={this.onTextChangeHandler.bind(this)}
                dropDownData={this.props.dropDownData} 
                addContactValueArr={this.state.addContactValueArr} 
                addContactEncValueArr={this.state.addContactEncValueArr} />
            </div> </div></div>
        <div className={classes.PrefContent}>
          <div><div><div className={classes.notificationLabel}>
            <img className={classes.labelImages} src={this.textIcon} alt="Text Icon" />{this.props.strings.emergencyAlertTextNotiTxt}</div><div className={classes.limitText}>{this.props.strings.limitText}</div><div className={classes.dividerLine} />
          </div>
            <div className={classes.textBox}>
              <CPPAccordionComponent
                contactType={contactTypeArr[2].contactType}
                stateData={this.state}
                onAddContactClickHandler={this.onAddContactClickHandler.bind(this)}
                onAddContactCancelHandler={this.onAddContactCancelHandler.bind(this)}
                addContactButtonText={contactTypeArr[2].addAnotherContactText}
                onContactMethodCheckHandler={this.onContactMethodCheckHandler.bind(this)}
                onModifyCustomerPreference={this.onModifyCustomerPreference.bind(this)}
                onDoneEnabledButton={this.onDoneEnabledButton}
                onSelectDropDown={this.onTextChangeHandler.bind(this)}
                dropDownData={this.props.dropDownData}
                addContactValueArr={this.state.addContactValueArr}
                addContactEncValueArr={this.state.addContactEncValueArr}  />
            </div> </div></div>
        <div className={classes.PrefContent}>
          <div><div><div className={classes.notificationLabel}>
            <img className={classes.labelImages} src={this.phoneIcon} alt="Phone Icon" />{this.props.strings.emergencyAlertVoiceNotiTxt}</div><div className={classes.limitText}>{this.props.strings.limitText}</div><div className={classes.dividerLine} />
          </div>
            <div className={classes.textBox}>
              <CPPAccordionComponent
                contactType={contactTypeArr[1].contactType}
                stateData={this.state}
                onAddContactClickHandler={this.onAddContactClickHandler.bind(this)}
                onAddContactCancelHandler={this.onAddContactCancelHandler.bind(this)}
                addContactButtonText={contactTypeArr[1].addAnotherContactText}
                onDoneEnabledButton={this.onDoneEnabledButton}
                onContactMethodCheckHandler={this.onContactMethodCheckHandler.bind(this)}
                 onModifyCustomerPreference={this.onModifyCustomerPreference.bind(this)}                
                onSelectDropDown={this.onTextChangeHandler.bind(this)}
                dropDownData={this.props.dropDownData} 
                addContactValueArr={this.state.addContactValueArr}
                addContactEncValueArr={this.state.addContactEncValueArr} />
            </div></div></div>
            {(!this.props.isViewEdit) ? <div className='row'>
                <div className='col-xs-12'>
                    <EmergencyAlertTermsAndCondition handleTermsCallback={this.onTncCheck} isTnCSelected={this.state.isTnCSelected} showCheckboxError={this.state.showCheckboxError} />
                    <SceErrorBox errorMessage={this.props.strings.tncError} isError={this.state.showCheckboxError} />
                </div>
            </div>:null}
            </div>
        <div className={'row ' + ' ' + classes.buttonsCenter}>
          <div className={'col-xs-12 col-sm-6 col-sm-push-2 ' + ' ' + classes.paddingCenter}>
            <span  className={classes.turnOnBtn}>
              {doneButton ? <SceButton id={!this.props.isViewEdit ? "emergencyAlertTurnOn":"emergencyAlertDone"} iconType='rightArrow' buttonType='sceDisabled' value={buttonText} /> :
                <SceButton id={!this.props.isViewEdit ? "emergencyAlertTurnOn":"emergencyAlertDone"} iconType='rightArrow' buttonType={(turnOnButtonType) ? 'sceDisabled' : 'primary'} value={buttonText} onClick={() => this.onFormDataSaveClickHandler()} />}
            </span><br />
            {!this.props.isViewEdit?<span className={classes.cancelBtn}><SceButton id='emergencyAlertCancel' iconType='cancel' buttonType='default' value={this.props.strings.cancel} onClick={this.props.closePopup} /></span>:null}
          </div></div> 
          </div>}
          </div>);}

  render() {
    let view = this.getViewToShow();
    let mainHeaderText = this.props.isViewEdit ?  this.props.strings.viewEditHeader:this.props.strings.emergencyAlertTuronHeader;
    return (
      <FocusTrap focusTrapOptions={{ allowOutsideClick: true}} >
      <div  className={classes.Main}> <div tabIndex="0" className={[overlayClasses.sceOverlay, classes.sceSetNotificationsDialog].join(' ')}> <div className={overlayClasses.sceOverlayContent}> <div ref={this.setWrapperRef} className={[classes.sceDialogBox, classes.dilogBox].join(' ')}>
        {view}
      </div></div></div>;
        </div>
      </FocusTrap>
    );
  }
}